import { inject, Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class UserGroupsApiService {
    private api: ApiService = inject(ApiService);

    // GET Requests
    public applyForGroup = this.api.getFetcher().path('/user-groups/apply').method('post').create();
    public leaveGroup = this.api.getFetcher().path('/user-groups/leave').method('post').create();
}
